/** Ground footprint of one photo (spec §4.1 step 1). The long sensor side lies across the flight line. */
import type { Camera } from './types';

export interface Footprint {
  across_m: number;
  along_m: number;
  gsd_cm: number;
}

export function footprint(camera: Camera, agl_m: number): Footprint {
  const across_m = (agl_m * camera.sensor_width_mm) / camera.focal_mm;
  const along_m = (agl_m * camera.sensor_height_mm) / camera.focal_mm;
  return { across_m, along_m, gsd_cm: (100 * across_m) / camera.image_width_px };
}

export function spacings(fp: Footprint, forwardOverlap: number, sideOverlap: number): { line_m: number; photo_m: number } {
  return { line_m: fp.across_m * (1 - sideOverlap / 100), photo_m: fp.along_m * (1 - forwardOverlap / 100) };
}
